module.exports = {"520321100":"南白镇","520321101":"龙坑镇","520321102":"三岔镇","520321103":"苟江镇","520321104":"三合镇","520321105":"乌江镇","520321106":"虾子镇","520321107":"三渡镇","520321108":"新舟镇","520321109":"永乐镇","520321110":"龙坪镇","520321111":"喇叭镇","520321112":"团溪镇","520321113":"铁厂镇","520321114":"西坪镇","520321115":"尚嵇镇","520321116":"茅栗镇","520321117":"新民镇","520321118":"鸭溪镇","520321119":"石板镇","520321120":"乐山镇","520321121":"枫香镇","520321122":"泮水镇","520321123":"马蹄镇","520321124":"沙湾镇","520321125":"松林镇","520321126":"毛石镇","520321127":"山盆镇","520321128":"芝麻镇","520321200":"平正仡佬族乡","520321201":"洪关苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520321.json
// module id = 2465
// module chunks = 0